// extracted by mini-css-extract-plugin
export var completionBody = "_c4-2";
export var completionCard = "_c4-0";
export var completionFooter = "_c4-3";
export var completionTitle = "_c4-1";